import type { GraphEdgeSettings } from '@ipfabric/utils';
import { detailedDiff } from 'deep-object-diff';

export interface GraphEdgeSettingsDiff {
  added: Partial<GraphEdgeSettings>;
  deleted: Partial<GraphEdgeSettings>;
  updated: Partial<GraphEdgeSettings>;
}

export const diffGraphEdgeSettings = (
  originalSettings: GraphEdgeSettings | undefined,
  updatedSettings: GraphEdgeSettings | undefined,
): GraphEdgeSettingsDiff | undefined =>
  originalSettings &&
  updatedSettings &&
  (detailedDiff(originalSettings, updatedSettings) as GraphEdgeSettingsDiff);
